<script>
  import _ from 'lodash'

  export default {
    name: 'ButtonSelect',
    props: {
      value: {
        type: Object,
        default: () => null
      },
      items: {
        type: Array,
        default: () => [],
        required: true
      },
      header: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        active: 0
      }
    },

    computed: {
      valueLabel() {
        if (_.isEmpty(this.value)) return ''
        if (this.$vuetify.breakpoint.xs) return this.value.initials
        return `[ ${this.value.initials} ] ${this.value.name}`
      }
    },
    watch: {
      value() {
        this.update()
      },
      items() {
        this.update()
      }
    },

    mounted() {
      this.update()
    },

    methods: {
      update() {
        this.active = _.findIndex(this.items, this.value)
      }
    }
  }
</script>

<template>
  <VMenu top right offset-y origin="top right" nudge-top="5" :disabled="items.length === 1" max-height="388px">
    <template v-slot:activator="{ on }">
      <VBtn text small v-on="on">
        {{ valueLabel }}
        <VIcon v-if="items.length > 1" right>mdi-chevron-up</VIcon>
      </VBtn>
    </template>

    <VList dense>
      <VSubheader v-if="header" class="text-uppercase" v-text="header"></VSubheader>
      <VListItemGroup v-model="active" color="primary">
        <VListItem v-for="(item, index) in items" :key="index" two-line :title="item.description" @click="$emit('change', item)">
          <VListItemContent>
            <VListItemTitle>{{ item.initials }}</VListItemTitle>
            <VListItemSubtitle>{{ item.name }}</VListItemSubtitle>
            <VListItemSubtitle class="font-weight-regular">
              {{ $vuetify.lang.t(`$vuetify.groups.${item.organizationGroup}`) }}
            </VListItemSubtitle>
          </VListItemContent>
        </VListItem>
      </VListItemGroup>
    </VList>
  </VMenu>
</template>

<style lang="scss" scoped>
  .button-select {
    position: relative;
  }
</style>
